<template lang="es">
<div class="profile">
    <Navigation></Navigation>

    <div class="container add_top_30 add_bottom_30">
        <div class="row">
			
            <Loader :show="saving" ></Loader>

            <div class="col col-lg-3">
                <ProfileSidebar></ProfileSidebar>
            </div>
            
            <div class="col-md-12 col-lg-9" v-if="loading" >
                <Loader :show="loading" type="inline"></Loader>
            </div>

			<div class="col-md-12 col-lg-9" v-if="!loading" >
                <div class="container box_general">
                    <div class="header_box">
                        <h2><i class="pe-7s-date"></i>Reserva #{{booking.code}}</h2>
                        <h4>
                            <span class="badge badge-warning" v-if="booking.status=='AWAITING_PAYMENT'">Pendiente de pago</span>
                            <span class="badge badge-danger" v-if="booking.status=='FAILED_PAYMENT'">Pago rechazado</span>
                            <span class="badge badge-light" v-if="booking.status=='REFUNDED_PAYMENT'">Pago devuelto</span>
                            <span class="badge badge-success" v-if="booking.status=='CONFIRMED'">Confirmada</span>
                            <span class="badge badge-success" v-if="booking.status=='VIDEO_LIVE'">VideoConsulta en curso</span>
                            <span class="badge badge-light" v-if="booking.status=='DONE' || booking.status=='VIDEO_ENDED'">Realizada</span>
                            <span class="badge badge-danger" v-if="booking.status=='CANCELLED_BY_USER'">Pendiente de devolución</span>
                            <span class="badge badge-danger" v-if="booking.status=='CANCELLED_BY_MEDIC'">Cancelada</span>
                            <span class="badge badge-danger" v-if="booking.status=='CANCELLED'">Cancelada</span>
                            <span class="badge badge-warning" v-if="booking.status=='RECLAIMED'">Reclamada</span>
                            <span class="badge badge-info" v-if="booking.status=='MEDIC_REQUEST_RESCHEDULE'">Reagenda solicitada</span>
                        </h4>
                    </div>

                    <div class="row"  >
                        <div class="col-md-8" >
                            <h5>Calificar consulta</h5>
                            <p>¿Cómo fué tu experiencia en la consulta? Ayudanos a mejorar nuestro servicio calificando al profesional que te ha atendido.</p>

                            <div class="book-data mt-3" >
                                <div class="box m-auto d-flex align-center justify-content-between" style="width:340px">
                                    <div class="value">Amabilidad</div>
                                    <div class="value">
                                        <star-rating :star-size="20" :read-only="false" :show-rating="false" v-model="amability"  inactive-color="#ddd" :inline="true" ></star-rating>
                                    </div>
                                </div>
                                <div class="box m-auto d-flex align-center justify-content-between" style="width:340px">
                                    <div class="value">Puntualidad</div>
                                    <div class="value">
                                        <star-rating :star-size="20" :read-only="false" :show-rating="false" v-model="puntuality"  inactive-color="#ddd" :inline="true" ></star-rating>
                                    </div>
                                </div>
                                <div class="box m-auto d-flex align-center justify-content-between" style="width:340px">
                                    <div class="value">Higiene</div>
                                    <div class="value">
                                        <star-rating :star-size="20" :read-only="false" :show-rating="false" v-model="cleaning"  inactive-color="#ddd" :inline="true" ></star-rating>
                                    </div>
                                </div>
                            </div>
    
                            <div class="w-100 d-flex align-center mt-4 mb-4" >                            
                                <div class="btn m-auto btn-success" @click="save" >Calificar</div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="medic-info">
                                <figure class="mb-3">
                                    <div class="avatar" v-if="booking.medic.picture" :style="'background-image:url('+API_URL+booking.medic.picture.url+')'"></div>
                                    <div class="avatar" v-if="!booking.medic.picture && booking.medic.gender=='Dra.'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-female.jpg')+')'"></div>
                                    <div class="avatar" v-if="!booking.medic.picture && booking.medic.gender!='Dra.'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-male.jpg')+')'"></div>
                                </figure>
                                
                                <div class="especialities">
                                    <small  v-for="medicEspeciality in booking.medic.medicEspecialities" :key="medicEspeciality.id">
                                        {{medicEspeciality.especiality.name}}
                                    </small>
                                </div>
                                
                                <h1>{{booking.medic.fullname}}</h1>
                                
                                <div v-if="booking.medic.rate>0">
                                    <star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="booking.medic.rate"  inactive-color="#ddd" :inline="true"></star-rating>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import Navigation from '@/components/Navigation'
import ProfileSidebar from '@/components/ProfileSidebar'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'

export default {
	name: 'bookingRate',
	metaInfo() {
		return {
			title: 'Reserva # ' + this.booking.code,
		}
	},
	components: {
		Navigation,
		Footer,
		Loader,
		ProfileSidebar,
	},
	data() {
		return {
			loading: true,
			saving: false,
			booking: {},
			amability: 0,
			puntuality: 0,
			cleaning: 0,
			API_URL: process.env.VUE_APP_API_URL,
		}
	},
	computed: {
		...mapGetters(['isAuthenticated', 'loggedUser']),
	},
	methods: {
		save() {
			if (!this.saving) {
				this.saving = true
				let dataInput = {
					amability: this.amability,
					puntuality: this.puntuality,
					cleaning: this.cleaning,
				}
				this.$apollo
					.mutate({
						mutation: gql`
							mutation($id: ID!, $data: BookingRateInput!) {
								bookingRate(id: $id, data: $data) {
									id
									status
								}
							}
						`,
						variables: {
							id: this.booking.id,
							data: dataInput,
						},
					})
					.then(() => {
						this.$toast.success('Consulta calificada')
						this.$router.push(`/bookings/${this.booking.id}`)
						this.saving = false
					})
					.catch(() => {
						this.$toast.error('Oops!')
						this.saving = false
					})
			}
		},
	},
	apollo: {
		me: {
			query: gql`
				query($id: ID!) {
					me {
						booking(id: $id) {
							id
							code
							price
							channel
							status
							comments
							user {
								email
								doc_type
								doc_number
							}
							medicEspeciality {
								title
								especiality {
									name
									slug
								}
							}
							medic {
								id
								fullname
								prefix
								gender
								picture {
									url
								}
								medicEspecialities {
									id
									title
									university
									description
									price
									status
									especiality {
										name
									}
									medicSubespecialities {
										subespeciality {
											name
										}
									}
								}
								rate
							}
							timeslot {
								datetime
								status
							}
							userCanRate
						}
					}
				}
			`,
			fetchPolicy: 'no-cache',
			variables() {
				return {
					id: this.$route.params.id,
				}
			},
			result(data) {
				//si la reserva fue cancelada pr el medico Y tiene el flag de reagendar, abro directamente la reangenda.
				this.booking = data.data.me.booking[0]
				if (!this.booking) {
					this.$router.push('/bookings')
				}
				if (!this.booking.userCanRate) {
					this.$toast.error('Esta consulta ya ha sido calificada')
					this.$router.push(`/bookings/${this.booking.id}`)
				}
				this.loading = false
			},
		},
	},
}
</script>

<style scoped>
.book-data {
	width: 100%;
}
.book-data .box {
	padding: 12px 8px;
}
.book-data .box:not(:last-child) {
	border-bottom: solid 1px #ededed;
}
.book-data .box .subtitle {
	font-size: 12px;
	text-transform: uppercase;
	color: #666;
}
.book-data .box .value {
	font-size: 18px;
	text-transform: capitalize;
	line-height: 18px;
}
.book-data .box .value p {
	font-size: 14px;
	text-transform: none;
	line-height: 14px;
}

.medic-info {
	border-left: solid 1px #ededed;
	padding: 18px;
	text-align: center;
}
.medic-info figure {
	width: 90px;
	margin: auto;
	border-radius: 45px;
	overflow: hidden;
}

.medic-info .rating {
	margin-bottom: 20px;
	display: inline-block;
}

.medic-info small {
	text-transform: uppercase;
	color: #999;
	font-weight: 600;
}

.medic-info h1 {
	font-size: 18px;
}

.actions-box {
	border-top: 1px solid #ededed;
	width: 100%;
	padding: 12px 8px;
}
</style>
